import axios from "axios";

const directoryApi = axios.create({
  baseURL:
    process.env.REACT_APP_TRATAZ_API_BASE_URL ||
    "https://trataz-api-staging-cedb833a27b8.herokuapp.com",
  timeout: 10000,
});

const normalizeCityPrefix = (city) =>
  city
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .slice(0, 3)
    .toUpperCase();

export async function getProfessionalDirectory({ state, city, limit = 20 }) {
  const cityPrefix = city ? normalizeCityPrefix(city) : "";

  const { data } = await directoryApi.get("/auth/professionals/directory", {
    params: {
      ...(state ? { state } : {}),
      ...(cityPrefix.length >= 3 ? { cityPrefix } : {}),
      limit,
    },
  });

  return data.data;
}
